export class OrganisationRoleReferenceModel {
    public organisationRoleCode: string;
    public organisationRoleName: string;
}